import { render, staticRenderFns } from "./OrganizationSelectBox.vue?vue&type=template&id=666b923b&scoped=true&"
import script from "./OrganizationSelectBox.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666b923b",
  null
  
)

export default component.exports